import { graphql } from 'react-relay';

export const TaskFragmentScheduleItem = graphql`
    fragment TaskFragmentScheduleItem on Task {
        scheduleItem {
            id
            type
            status
            start_format_datetime
            end_format_datetime
            duration
            project {
                id
                name
                number
            }
            statusItem {
                name
            }
            typeItem {
                name
            }
            name
            ...ScheduleItemFragment
        }
    }
`;
